import { FETCH_PARTNER_DATA_SUCCESS } from "app/reducers/partnerActionTypes";

const defaultState = {};

export default function pagesReducer(state = defaultState, action) {
	switch (action.type) {
		case FETCH_PARTNER_DATA_SUCCESS: {
			const data = action?.res?.data;
			return data?.pages || {};
		}
		default:
			return state;
	}
}
